module.exports = __webpack_public_path__ + "static/img/cabinet5_3.85128828.gif";